module.exports = __webpack_public_path__ + "static/media/QUICKPAY.6f1642e6.png";